'use strict';

define(['underscore'], function (_) {
    return function (AvailabilityService, LoadSaveService, $q, TranslateService) {
        var translateFn = TranslateService.instant;

        return {
            contactDetails: function contactDetails(step, junction) {
                step('hoContactDetails', true).onNext.goTo('hoContactDetailsComplete').skipOnResumeIf(function (_ref) {
                    var submission = _ref.value;
                    return submission.persons[0].emailAddress1;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.wizard.step.Your Info');
                });

                junction('hoContactDetailsComplete');
            },
            //This is commented now for pre-qual questions
            //May need a check for portal agent ***Start****
            coverables: function coverables(step, junction) {
                step('hoPrequalQuestions', true).onNext.goTo('hoMembership').skipOnResumeIf(function (_ref2, _ref3) {
                    var submission = _ref2.value;
                    var agentportalnewsubmission = _ref3.agentportalnewsubmission;

                    if (agentportalnewsubmission) {
                        return false;
                    }
                    if (submission.draftData.lobs.homeowners.preQualQuestionSets) {
                        var answerValues = _.values(submission.draftData.lobs.homeowners.preQualQuestionSets[0].answers);
                        return answerValues.some(function (value) {
                            return value !== null;
                        });
                    }
                    return false;
                }).isValid(function (model, formValid) {
                    return model.aspects.valid && model.aspects.subtreeValid && formValid;
                }).label(function () {
                    return translateFn('quoteandbind.wizard.step.Qualification');
                });
                //***end****
                step('hoMembership').onNext.goTo('hoAdditionalInfo').skipOnResumeIf(function (_ref4) {
                    var submission = _ref4.value;
                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.occupancy;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.wizard.step.Membership');
                });

                step('hoAdditionalInfo').onNext.goTo('hoYourHome').skipOnResumeIf(function (_ref5) {
                    var submission = _ref5.value;
                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.hoAdditionalInfo;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
                });

                step('hoYourHome').onNext.goTo('hoConstruction').skipOnResumeIf(function (_ref6) {
                    var submission = _ref6.value;
                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.hoYourHome;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
                });

                step('hoConstruction').onNext.goTo('hoRating').skipOnResumeIf(function (_ref7) {
                    var submission = _ref7.value;
                    return submission.draftData.lobs.homeowners.construction;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
                });

                step('hoRating').onNext.goTo('hoCoverablesComplete').skipOnResumeIf(function (_ref8) {
                    var submission = _ref8.value;
                    return submission.draftData.lobs.homeowners.rating && submission.quoteData;
                }).isValid(function (model) {
                    return model.aspects.valid && model.aspects.subtreeValid;
                }).label(function () {
                    return translateFn('quoteandbind.ho.wizard.step.Discount');
                });

                junction('hoCoverablesComplete');
            } /*,
                     moreInfo: (step, junction) => {
                         step('hoPolicyInfo', true)
                         .onNext.goTo('hoMoreInfoComplete')
                         .skipOnResumeIf(({value: submission}) => submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1)
                         .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                         .label(() => translateFn('quoteandbind.wizard.step.Policy Info'));
                  junction('hoMoreInfoComplete');
              }*/
        };
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./app/customer/js/src/edge/quoteandbind/ho/config/FlowConfig.js
 ** module id = 458
 ** module chunks = 0
 **/